import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH ARTICLE TO EDIT ********************
export const fetchArticle = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ARTICLE_LOADING,
			payload: true
		});

		const response = await services.get(`/products/articles/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ARTICLE_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_ARTICLE_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
